var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodeinline = function SvgCodeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.077,
    d: "M5.309 4.693V9.2M13 2.693V11M6 11v3.506H4V11M15 2.645a.6.6 0 0 0-.082-.31.65.65 0 0 0-.226-.234.68.68 0 0 0-.64-.041C11.497 3.207 8.972 4.244 3.668 4.267H3c-.53 0-1.04.204-1.414.567A1.9 1.9 0 0 0 1 6.202v1.29c0 .513.21 1.005.586 1.367.375.363.884.567 1.414.567h.667c5.304.023 7.829 1.06 10.386 2.207a.69.69 0 0 0 .639-.041.65.65 0 0 0 .226-.234.6.6 0 0 0 .082-.31z"
  })));
};
export default SvgCodeinline;